<template>
  <div>
    <section class="permanently-close-acc">
      <div class="sidebar-container"></div>
      <div class="main-contents">
        <div class="my-will-section">
        <v-card>
          <h3 class="decorateCls">FinStat</h3>
          <p>
           FinStat brings to you various financial data about the market and presents them in a user-friendly manner.
          </p>
          <p>
           You can now compare FD rates within banks, term & health insurance premiums across insurers, mutual fund performance, stock trends etc., on the click of a button.
          </p>
          <p>
            Please feel free to share with your friends and family who might benefit from this information..
          </p>
          <p>
           Check out our latest posts and articles here.
          </p>
        <br>
          <div class="button-container">
            <button class="nemia-button mr-2" @click="backButton">CANCEL</button>
            <button class="nemia-button active" @click="proceedButton">
             PROCEED 
            </button>
          </div>
        </v-card>
        </div>
      </div>
    </section>  
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    data : () =>({
    }),
    methods:{
      backButton(){
        this.$router.push({ name: "SudLifeFinStat"}).catch(()=>{});
      },
      proceedButton(){
        this.$router.push({ name: "SudLifeFinStatCategory"}).catch(()=>{});
      },
    }
  }
</script>

<style>
  .will-box{
    height: 600px;
  }
  .will-text{
    text-align: center;
  }
  .breadcrumb-list li:first-child {
    color: #F19700;
  }
  .breadcrumb-list li {
    display: inline-block;
    padding-bottom: 6px;
    font-size: 13px;
    color: #999999;
  }
  .decorateCls{
    color:#F19700 !important; 
    text-decoration:underline;
  }
</style>